import { sumQuantities, validMarbleQuantity } from "./marbleQuantity";

const dimensions = new Intl.NumberFormat("en-GB", {maximumFractionDigits:3});
export const saleSizeLabel = (width, height) =>
  Number(width) > 0 && Number(height) > 0 ? `L ${dimensions.format(Number(height))} × W ${dimensions.format(Number(width))} m` : "—";

export const saleSizeGroups = row => row.size_groups || [{slabs_sold:row.slabs_sold,width:row.width,height:row.height}];

function rounded(value, digits) {
  const scaled = value * 10 ** digits;
  return Math.round(scaled + Number.EPSILON * Math.max(1, Math.abs(scaled))) / 10 ** digits;
}

export function saleSizeTotals(group, price) {
  const area = rounded(Number(group.slabs_sold || 0) * Number(group.width || 0) * Number(group.height || 0), 3);
  return {area, total:rounded(area * Number(price || 0), 2)};
}

export function calculateSaleRow(row) {
  const totals = saleSizeGroups(row).map(group => saleSizeTotals(group, row.price_per_m2));
  const area = totals.reduce((sum, group) => sum + group.area, 0);
  const total = totals.reduce((sum, group) => sum + group.total, 0);
  return {...row, area_sold:area ? area.toFixed(3) : "", total_price:total ? total.toFixed(2) : ""};
}

export function validateSaleSizes(row) {
  if (!validMarbleQuantity(row.slabs_sold)) return "Enter a positive total quantity with up to three decimal places.";
  const groups = saleSizeGroups(row);
  if (!groups.length || groups.some(group => !validMarbleQuantity(group.slabs_sold) ||
    [group.width,group.height].some(value => !Number.isFinite(Number(value)) || Number(value) <= 0))) {
    return "Enter a positive quantity, length and width for every size group.";
  }
  if (sumQuantities(groups.map(group => group.slabs_sold)) !== Number(row.slabs_sold)) {
    return "Size group quantities must add up to the total quantity.";
  }
  return "";
}

export const saleSizeItems = (rows, pickDistribution) => rows.flatMap(row => saleSizeGroups(row).map(group => ({
  distribution_id:Number(row.distribution_id || pickDistribution(row.block_id)),
  block_id:Number(row.block_id), slabs_sold:Number(group.slabs_sold),
  width:Number(group.width), height:Number(group.height), price_per_m2:Number(row.price_per_m2),
})));
